import React, { useEffect, useState } from 'react';
import { loadingStore } from '../utils/loadingStore';

const spinner = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className="animate-spin"
    width={32}
    height={32}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <circle cx="12" cy="12" r="9" strokeOpacity="0.25" />
    <path d="M21 12a9 9 0 0 1-9 9" />
  </svg>
);

export const LoadingOverlay: React.FC = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const unsub = loadingStore.subscribe(setCount);
    return unsub;
  }, []);

  if (count <= 0) return null;

  return (
    <div
      aria-label="Loading"
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ backgroundColor: 'rgba(255,255,255,0.6)', backdropFilter: 'blur(1px)' }}
    >
      <div className="flex items-center gap-3 text-gray-700">
        {spinner}
        <span>読み込み中...</span>
      </div>
    </div>
  );
};

export default LoadingOverlay;
